import { useTranslation } from 'react-i18n-lite'
import ActivityValue from './ActivityValue'
import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import { Col, Row, Text } from '@yes.technology/react-toolkit'
import { StatusClass } from 'types/shared'

interface ActivityDocumentFileProps {
  values: string
  label: string
  statusClass?: StatusClass
}

const ActivityDocumentFile = ({
  values,
  label,
  statusClass
}: ActivityDocumentFileProps) => {
  const { t } = useTranslation()
  const obj = JSON.parse(values)
  return (
    <>
      {label && (
        <Row className='mb-2'>
          <Col lg={12}>
            <Text as='label' variant='label-03'>
              {label}
            </Text>
          </Col>
        </Row>
      )}

      <ActivityValue
        label={t('activity-document-file.labels.des')}
        value={obj.des}
        statusClass={statusClass}
      />
      <ActivityValue
        label={t('activity-document-file.labels.document-id')}
        value={obj.uuid}
        statusClass={statusClass}
        placeholder={t('activity-document-file.placeholders.uuid')}
      />
      <ActivityValue
        label={t('activity-document-file.labels.status')}
        value={obj.statusDes}
        statusClass={statusClass}
        placeholder={t('activity-document-file.placeholders.status')}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-file.labels.content-type')}
            value={obj.contentType}
            statusClass={statusClass}
            placeholder={t('activity-document-file.placeholders.content-type')}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-file.labels.size')}
            value={obj.size ? formatFileSize(Number(obj.size)) : ''}
            statusClass={statusClass}
            placeholder={t('activity-document-file.placeholders.size')}
          />
        </div>
      </div>
      <ActivityValue
        label={t('activity-document-file.labels.file-name')}
        value={obj.originalFilename}
        statusClass={statusClass}
        placeholder={t('step.review.empty-state.document_file')}
      />
    </>
  )
}

export default ActivityDocumentFile
